import { inject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { SnapshotTypeService } from 'pages/system-fields/snapshot-types/service';
import { DialogService } from 'aurelia-dialog';
import { formatTableLink, creatTableButton } from 'resources/utility';
import toastr from 'toastr';

@inject(SnapshotTypeService, DialogService, EventAggregator)
export class SnapshotTypes {
    constructor(snapshotTypeService, dialogService, ea) {
        this.ea = ea;
        this.snapshotTypeService = snapshotTypeService;
        this.dialogService = dialogService;

        this.columns = [
            { dataField: 'name', sortOrder: 'asc', cellTemplate: (container, options) => formatTableLink({ container, containerOptions: options, callback: this.edit }) },
            { caption: 'Actions', cellTemplate: (container, options) => creatTableButton({ container, containerOptions: options, style: 'danger', label: 'Delete', action: this.delete }), allowExporting: false }
        ];

        this.subscription = this.ea.subscribe('snapshot-types:updated', () => {
            this.grid.refresh();
        });
    }

    deactivate () {
        this.subscription.dispose();
    }

    delete = (stage) => {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('resources/elements/modals/confirm/index') }).whenClosed(async response => {
            if (!response.wasCancelled) {
                await this.snapshotTypeService.delete(snapshotType.id);
                this.grid.refresh();
                toastr.success('Snapshot Type was deleted!');
            }
        });
    };

    add() {
        this.dialogService.open({ viewModel: this.snapshotTypeService.editor });
    }

    edit = (data) => {
        this.dialogService.open({ viewModel: this.snapshotTypeService.editor, model: { id: data.id } });
    };
}